export default __webpack_public_path__ + "static/media/image.9485b60c.svg";